export default {
  global: {
    more: 'More',
    title1: 'SR Biomedical',
    title2: 'Patent Management System'
  },

  login: {
    login: 'Log in'
  },

  flow: {
    step: 'Step'
  },

  homes: {
    company: 'Companies',
    project: 'Projects',
    patent: 'Patents',
    process: 'Processes',
    /** card */
    pendingMyApproval: 'Pending My Approval',
    pendingMyRequest: 'Pending My Request',
    overdueReminder: 'Overdue Reminder',
    projectStatus: 'Project Status',
    patentStatus: 'Patent Status',
    percentageOfCompanyTechnology: 'Company Tech Area Counts',
    percentageOfProjectPhases: 'Project Counts in Phase Per Tech Area',
    patentsTop10: 'Patents in Top 10 Countries',
    /**  */
    companyProcess: 'Company Process | Company Processes',
    projectProcess: 'Project Process | Project Processes'
  },

  /* 菜单 */
  menu: {
    home: 'Home',
    homes: {
      toolManagerHome: 'Tool Manager Home',
      companyManagerHome: 'Company Manager Home',
      projectManagerHome: 'Project Manager Home',
      countryManagerHome: 'Patent Manager Home'//'Country Manager Home'
    },
    patentManagement: 'Patent Mgt',
    generalProcessManagement: 'General Process Mgt',
    processApprovalManagement: 'Process Approval Mgt',
    templateManagement: 'File Mgt',
    adminManagement: 'Admin Mgt',
    viewCompanyInfo: 'View Company Info',
    addGeneralProcess: 'Add General Process',
    editGeneralProcess: 'Edit General Process',
    viewGeneralProcess: 'View General Process',
    updateCompanyInfo: 'Update Company Info',
    companyManagement: 'Company Mgt',
    projectManagement: 'Project Mgt',
    userDataAccess: 'Project Data Access',
    templateLibrary: 'File Library',
    accountManagement: 'Account Mgt',
    roleManagement: 'Role Mgt',
    roleGrantAuthorization: 'Role Grant Authorization',
    messageManagement: 'Message Mgt',
    dataDictionary: 'Data Dictionary',
    editCompanyProcess: 'Edit Company Process',
    viewCompanyProcess: 'View Company Process',
    companyProcessAuditList: 'Company Process',
    auditCompanyProcess: 'Audit Company Process',
    viewCompanyProcessAudit: 'View Company Process Audit',
    editProjectProcess: 'Edit Project Process',
    viewProjectProcess: 'View Project Process',
    approvalCompanyProcess: 'Approval Company Process',
    approvalProjectProcess: 'Approval Project Process',
    projectProcessAuditList: 'Project Process',
    auditProjectProcess: 'Audit Project Process',
    viewProjectProcessAudit: 'View Project Process Audit',
    patentAdd: 'Add Patent',
    patentEdit: 'Edit Patent',
    patentView: 'View Patent',
    projectProcessExcute: 'Project Process Implementing',
    companyInformationView: 'Update Company Information',
    companyInfoView: 'View Company Information',
    generalProcessAdd: 'Add General Process',
    generalProcessEdit: 'Edit General Process',
    generalProcessView: 'View General Process',
    generalProcessCopy: 'Copy General Process',
    companyProcessEdit: 'Edit Company Process',
    companyProcessView: 'View Company Process',
    companyProcessListView: 'Company Process List',
    projectProcessEdit: 'Edit Project Process',
    projectProcessView: 'View Project Process',
    privilegeManagement: 'Assign Data Access',
    accountManagementDetails: 'Account Management Details',
    roleManagementDetails: 'Role Management Details',
    dataDictionaryDetails: 'Data Dictionary Details',
    projectAddEditView: 'Project Edit',
    projectAdd: 'Project Add',
    projectView: 'Project View',
    projectUpdatePlanView: 'Project Update Plan',
    projectUserDataViewDetail: 'Project User Data View',
    stationNews: 'Station News',
    stationNewsDetails: 'Station News Detail',
    changePassword: 'Change Password',
    patentEmpower: 'Patent Data Access'
  },

  /* 按钮 */
  button: {
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    search: 'Search',
    reset: 'Reset',
    cancel: 'Cancel',
    next: 'Next',
    previousStep: 'Previous Step',
    save: 'Save',
    submit: 'Submit',
    resubmit: 'Resubmit',
    upload: 'Upload',
    import: 'Import',
    enable: 'Enable',
    disable: 'Disable',
    return: 'Return',
    process: 'Process',
    viewProcess: 'View Process',
    editProcess: 'Edit Process',
    generate: 'Report',
    revoke: 'Revoke',
    sync: 'Sync',
    addNode: 'Add Folder',
    addChildNode: 'Add Subfolder',
    deleteNode: 'Delete Folder',
    deleteFile: 'Delete File',
    uploadFile: 'Upload File',
    createFolder:'Create Subfolder',
    editFolder:'Edit Folder',
    deleteFolder:'Delete Folder',
    copyLink:'Copy Link',
    assign: 'Assign',
    send: 'Send',
    approve: 'Approve',
    reject: 'Reject',
    sure: 'Sure',
    confirm: 'Confirm',
    importTemplateDownload: 'Download Template File',
    plan: 'Plan',
    implementing: 'Implementing',
    download: 'Download',
    allSelect: 'All Select',
    reverseSelect: 'Reverse Select',
    cancelSelect: 'Cancel Select',
    scan: 'Scan',
    authorize: 'Assign',
    updateSchedule:'Update Schedule',
    viewSchedule:"View Schedule",
    schedule: 'Schedule',
    push: 'Push',
    timeline: 'Timeline',
    copy: 'Copy'
  },

  /* 公共信息 */
  messageCommon: {
    success: 'Success',
    failed: 'Failed',
    error: 'Error',
    noData: 'No Data',
    operateSuccess: 'Operate Success',
    operateError: 'Operate Error',
    saveSuccess: 'Save Success',
    saveFailed: 'Save Failed',
    deleteSuccess: 'Delete Success',
    deleteFailed: 'Delete Failed',
    selectAtLeastOne: 'Select At Least One Record',
    confirmDelete: 'Confirm Delete',
    latestStepIsUnchecked: 'The latest project process is not approved. Are you sure to continue',
    request: 'Request',
    tips: 'Tips',
    beEmpty: 'is empty',
    beMandatory: 'is mandatory',
    noSelect: 'is not select',
    greaterThan: 'greater than',
    lessThan: 'less than',
    greaterThanOrEqualTo: 'greater than or equal to',
    lessThanOrEqualTo: 'less than or equal to',
    startTime: 'start time',
    endTime: 'end time',
    confirmOverwriteAfterSync: 'The edited information will be overwritten after synchronization,confirm continue?',
    confirmOnlyEmptyInfoAfterSync: 'Only field information that is blank will be overwritten after synchronization,confirm continue?',
    confirmFormatter: 'Confirm {0}',
    lengthSectionFormatter: 'Length bettwen {0} and {1} character',
    articleStepsErrorFormatter: 'Article {0} records,{1} {2}',
    articleRecordsErrorFormatter: 'Article {0} records,{1} {2}',
    articleStepsRecordsErrorFormatter: 'The step {0}, item {1}, action {2} {3}',//'Article {0} steps，article {1} records,{2} {3}',
    articleLinesInTableErrorFormatter: '{0}，article {1} lines，{2} {3}',
    onlyExtensions: 'You only can upload files whose extension are {0}',
    fileMaxSize: 'You only can upload files whose size are less than {0} M',
    itemTipWithName: '{0}:{1}, {2} {3}',
    itemCompareTipWithName: '{0}:{1} {2} must be {3} {0}:{4} {2}',
    itemCompareTipWithName2: '{0} {1} must be {2} {3} {1}',
    beEmptyFormatter: '{0} is empty',
    noSelectFormatter: '{0} is not select',
    sync: 'Sync',
    successFormatter: '{0} Success',
    failedFormatter: '{0} Failed',
    errorFormatter: '{0} Error'
  },

  /* 查询 form*/
  queryForm: {
    pleaseEnter: 'Please Enter',
    pleaseSelect: 'Please Select',
    selectDate: 'Select Date',
    companyName: 'Company Name',
    processName: 'Process Name',
    technicalArea: 'Technical Area',
    headQuarter: 'HeadQuarter',
    companyContractPerson: 'Company Contact Person',
    status: 'Status',
    projectName: 'Project Name',
    patentObjective: 'Patent Objective',
    patentType: 'Patent Type',
    country: 'Country',
    patentAppNo: 'Patent App. No',
    applyStartDate: 'Apply Start Date',
    applyEndDate: 'Apply End Date',
    submitStartDate: 'Submit Start Date',
    submitEndTime: 'Submit End Time',
    title: 'Title',
    content: 'Content',
    sendDate: 'Sent Date',
    waitAudit: 'Wait Audit',
    approve: 'Approve',
    reject: 'Reject',
    draft: 'Draft',
    createdBy: 'Created By',
    createdTime: 'Created Time',
    enable: 'Enable',
    disable: 'Disable',
    fllingStartDate: 'Flling Start Date',
    fllingEndDate: 'Flling End Date',
    composition: 'Composition',
    formulation: 'Formulation',
    process: 'Process',
    dosage: 'Dosage',
    use: 'Use',
    others: 'Others',
    inProsecution: 'In prosecution',
    grant: 'Grant',
    inactive: 'Inactive',
    expired: 'Expired',
    autoGenerate: 'Auto Generate',
    userName: 'User Name',
    companyEmail: 'Company Email',
    roleName: 'Role Name',
    state: 'State',
    authorized: 'Authorized',
    notAuthorized: 'Not Authorized',
    keywords: 'Keywords',
    dueDateNotification: 'Due Date Notification',
    systemNotification: 'System Notification',
    projectCode: 'Project Code',
    projectDevelopmentStatus: 'Dev. Status',
    mobilePhone: 'Mobile Phone',
    noStart: 'No Start',
    inProgress: 'In Progress',
    completed: 'Completed',
    whetherTheOverdue: 'Is overdue',
    yes: 'Yes',
    no: 'No',
    isAvaliable: 'Is Avaliable',
    pendingForApproval: 'Pending for approval',
    approved: 'Approved',
    rejected: 'Rejected',
    all: 'All',
    representative: 'Representative',
    member: 'Member'
  },

  /* table Form || form 表单*/
  formData: {
    companyProcessInformation: 'Company Process Information',
    processName: 'Process Name',
    phaseName: 'Dev. Stage',
    approve: 'Approve',
    view: 'View',
    technicalArea: 'Technical Area',
    status: 'Status',
    createdBy: 'Created By',
    createdTime: 'Created Time',
    preliminaryResearch: 'Preliminary Research',
    action: 'Action',
    comment: 'Comment',
    approvalComment: 'Approval Comment',
    approvalHistoryLog: 'Approval History Log',
    reason: 'Reason',
    time: 'Time',
    companyCode: 'Company Code',
    companyName: 'Company Name',
    entityType: 'Entity Type',
    headQuarter: 'Headquarter',
    numberOfEmployees: 'Number Of Employees',
    annualRevenue: 'Annual Revenue',
    companyLegalPerson: 'Company IP Head',//'CompanyLegal Person',
    companyCEO: 'Company CEO',
    companyContactPerson: 'Company Contact Person',
    mobilePhone: 'Mobile Phone',
    companyPhone: 'Company Phone',
    companyAddress: 'Company Address',
    companyDetailAddress: 'Company Detail Address',
    remarks: 'Remarks',
    uploadFile: 'Upload File',
    projectCount: 'Project Count',
    tips: 'Tips',
    pleaseInsertRejectReason: 'Please Insert Reject Reason',
    pass: 'Pass',
    reject: 'Reject',
    submit: 'Submit',
    systemSync: 'System Sync',
    enable: 'Enable',
    disable: 'Disable',
    projectName: 'Project Name',
    patentCode: 'SRBM Patent Code',
    patentObjective: 'Patent Objective',
    patentType: 'Patent Type',
    country: 'Country',
    patentAppNo: 'Patent App No',
    filingDate: 'Filing Date',
    isAvaliable: 'Is Avaliable',
    isAvaliable2: 'Is Avaliable',
    projectPhase: 'Dev. Stage',
    patentStatus: 'Legal Status',
    prosecution: 'Prosecution/Claim Strategy',
    docketNumber: "Client's Docket Number",
    prosecutionActions: 'Prosecution Actions',
    marketAuthorizationDate: 'Market Authorization Date',
    priorityList: 'Priority list',
    publicationNumber: 'Publication Number',
    publicationDate: 'Publication Date',
    grantPatentNo: 'Grant Patent No',
    grantDate: 'Grant Date',
    expiryDate: 'Expiry Date',
    expiryExpectedDate: 'Expiry Date/Expected Expiry Date',
    familyMembers: 'Family Member Of',
    no: 'No',
    activity: 'Activity',
    priorityNumber: 'Priority Number',
    priorityDate: 'Priority Date',
    userName: 'User Name',
    companyEmail: 'Company Email',
    roleName: 'Role Name',
    telephone: 'Telephone',
    estimatedStartDate: 'Estimated Start Date',
    estimatedEndDate: 'Estimated End Date',
    stepName: 'Step Name',
    introduction: 'Introduction',
    projectDevelopmentStatus: 'Project Dev Status',
    projectCode: 'Project Code',
    keywords: 'Keywords',
    patentCount: 'Patent Count',
    productNameResearchCode: 'Product Name/Research code',
    isThisInlicensed: 'Is this in-licensed?',
    contactIsAttached: 'Contact is attached?',
    indicationTherapeuticArea: 'Indication(Therapeutic Area)',
    summaryofthetechnical: 'Summary of the technical contents of the invention',
    inventionDisclosure: 'Invention Disclosure',
    isAvaliable1: 'Is Avaliable?',
    relevantDocumentSearch: 'Relevant Document Search',
    literature: 'Literature',
    patent: 'Patent',
    author: 'Author',
    title: 'Title',
    publication: 'Publication',
    date: 'Date',
    attachment: 'Attachment',
    patentNo: 'Patent No.',
    patentOwner: 'Patent Owner',
    projectStartStatus: 'Project Start Status',
    through: 'Approve',
    refusedTo: 'Refused To',
    pending: 'Pending',
    theDraft: 'The Draft',
    introductionLower: 'introduction',
    nameEn: 'English Name',
    generalInformation: 'General Information',
    patentInformation: 'Patent Information',
    familyMemberInformation: 'Family Member Information',
    devStage: 'Dev. Stage',
    legalStatus: 'Legal Status',
    SRBMPatentCode: 'SRBM Patent Code',
    appNo: 'App. No.',
    publicationNo: 'Publication No.',
    grantNo: 'Grant No.',
    priorityCountry: 'Priority Country',
    priorityAppNo: 'Priority App No.',
    priorityAppDate: 'Priority App Date',
    schedule: 'Schedule',
    isOnlyMainPatent: 'Is only sales reps',
    patentCategory: 'Patent Category'
  },

  checkList: {
    upload: 'Upload',
    pleaseEnter: 'Please Enter',
    attachments: 'Attachments',
    inProgress: 'In progress',
    done: 'Done',
    na: 'NA',
    generalAttachment: 'Process Attachment',
    projectAttachment: 'Project Attachment',
    areYouSureToDelete: 'Are you sure to delete this process?',
    tips: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteSuccessful: 'Delete Successful',
    pleaseUploadChecklistFile: 'Please Upload Checklist File',
    onlyExtensions: 'You only can upload files whose extension are {0}',
    fileMaxSize: 'You only can upload files whose size are less than {0} M',
    schedule:"Schedule",
    pleaseInsertSchedule:"Please Insert Schedule",
    pleaseInsertExplain:"Please Insert Explain",
    pleaseInsertLink:"Please Insert Link",
    linkName:"Link Name",
    hyperlink:"Hyperlink",
    addLink:"Link",
    pleaseInsertLinkName:"Please Insert Link Name",
    pleaseInsertHyperlink:"Please Insert Hyperlink",
    downloading:"Downloading"
  },

  companyAuditView: {
    companyName: 'Company Name',
    technicalArea: 'Technical Area',
    status: 'Status',
    submitStartDate: 'Submit Start Date',
    submitEndTime: 'Submit End Time',
    processName: 'Process Name',
    approve: 'Approve',
    view: 'View',
    createdBy: 'Created By',
    createdTime: 'Created Time',
    preliminaryResearch: 'Preliminary Research',
    action: 'Action',
    approvalComment: 'Comment',
    approvalHistoryLog: 'Approval History Log',
    reason: 'Reason',
    time: 'Time'
  },

  fileLibrary:{
    createSubfolder:'Create Subfolder',
    editFolder:'Edit Folder',
    deleteFolder:'Delete Folder',
    search:{
      m1:'Not Recursively',
      m2:'Recursively',
      placeholder:'Keywords'
    },
    button:{
      copyLink:'Copy Link',
      download:'Download',
      deleteFile:'Delete'
    },
    tip:{
      dirFirst:'Please select a directory first',
      copy:'The link has been copied to the clipboard',
      fileNameExsit:"The file name already exists. Whether to overwrite the original file. If not, please modify the file name and upload again.",
      fileNameExsitNoAccess:"The file name already exists and you do not have permission to access the original file. Please modify the file name before uploading"
    },
    form:{
      createSubfolder:'Create Subfolder',
      editFolder:'Edit Folder',
      folderName:'Folder Name',
      description:'Description'
    }
  },

  administration: {
    whole: 'Whole',
    effective: 'Effective',
    invalid: 'Invalid',
    userPhoto: 'User Photo',
    assign: 'Assign',
    Usermobilephone: 'User Mobile Phone',
    customertype: 'User Type',
    Superadministrator: 'Super Administrator',
    system: 'System',
    company: 'Company',
    project: 'Project',
    patent: 'Patent',
    role: 'Role Name',
    deleteAccount: 'Do you want to delete this account?',
    selectAccount: 'Please select a user account',
    resetPassword: 'Do you want to reset passwords in bulk（Initial password: 123456）?',
    deleteAccounts: 'Do you want to delete accounts in batch?',
    batchEnabled: 'Do you want to enable in batch?',
    batchDisable: 'Do you want to batch disable?',
    roleDescription: 'Role Description',
    roleStatus: 'Role Status',
    business: 'business',
    key: 'Key',
    value: 'Value',
    enValue: 'English value',
    chValue: 'Chinese value',
    enumerationName: 'Enumeration Name',
    describe: 'Description',
    dicValue: 'Value',
    dicTypeName: 'TypeName',
    dicSeq: 'Serial',
    sort: 'Sort',
    projectDevelopmentStatus: 'Project Development Status',
    authorized: 'Authorized',
    unauthorized: 'Unauthorized',
    projectCode: 'project Code',
    fileName: 'File Name',
    browseTemplates: 'Browse Templates',
    isIncludeChild: 'is Include Child',
    templateType: 'Template Type',
    FileName: 'File Name',
    FileSize: 'File Size',
    modifiedtemplatename: 'Please enter the modified template name',
    beAdded: 'Please select the location where the template type needs to be added',
    entertemplatename: 'Please enter template name',
    Deletetype: 'Delete the selected template type',
    Deletefile: 'Delete the selected template file',
    selectfile: 'Please select template file',
    batchdeletefiles: 'Do you want to delete template files in batch',
    uploadseat: 'Please select the location where the template file needs to be uploaded',
    paw: 'Password',
    verificationCode: 'Verification Code',
    getCode: 'Get Code',
    automaticLogin: 'Automatic login within 8 hours',
    userNameempty: 'User name cannot be empty',
    usermailboxempty: 'User mailbox cannot be empty',
    pawnot: 'Password cannot be empty',
    codenot: 'Verification code cannot be empty',
    OldPassword: 'Old Password',
    NewPassword: 'New Password',
    ConfirmPassword: 'Confirm Password',
    xentepassword: 'Please enter the old password',
    xentenewpassword: 'Please enter a new password',
    xentenewthepassword: 'Please enter the confirmation password',
    pwdpism: 'The two passwords are inconsistent, please re-enter',
    authorizationbatch: 'Do you want to cancel authorization in batch',
    authorizationnot: 'Confirm batch assignment?',//'Batch authorization or not',
    Incorrectmailboxformat: 'Incorrect mailbox format',
    Incorrectmobilenumber: 'Incorrect format of mobile number',
    PleaseuserAvatar: "Please enter the user's Avatar",
    uploadedpicture: 'The size of uploaded picture cannot exceed 10MB!',
    Pleaseselectarole: 'Please select a role',
    deleteroles: 'Do you want to batch delete roles?',
    pawTesting: "Pawtesting: 'password must be 8 to 12 digits and contain upper and lower case letters and numbers'",
    Logout: 'Logout',
    Noauthority: 'This user has all permissions of the company/system and no additional assignment is required',
    Companymailbox: 'Company mailbox cannot be empty',
    format: 'The uploaded image can only be in the format of. JPG,. PNG,. JPEG,. GIF,. TIF,. BMP!',
    manmgeuploadedpicture: 'The size of uploaded picture cannot exceed 200MB!',
    inputcharacters: 'Please input 1-50 characters',
    confirmtooverwrite:'Confirm to overwrite',
    Approvalstatus:'Approval status',
    projectStatus:'Project status',
    Rejected:'Rejected',
    Notyetbegun:'Not yet begun',
    roleType: 'Role Type'
  },

  tipsList: {
    companyToDisable: 'Please select the company to disable！',
    companyToEnable: 'Please select the company to enable！',
    youWantToDelete: 'Please select the company you want to delete！',
    deleteCompanyWill: 'Delete company will simultaneously delete all projects, processes and patent information under the company, whether to confirm the deletion！',
    deleteProjectWill: 'Delete project will simultaneously delete all processes, checklist and patent information under the project, whether to confirm the deletion！',
    deleteTheSuccess: 'Delete the success！',
    deleteFailed: 'Delete failed！',
    pleaseSelectUser: 'please Select User！',
    youWantUserAuthorization: 'Are you sure you want user authorization！',
    youWantToUndoTheUser: 'Are you sure you want to undo the user！',
    pleaseSelectTheFile: 'Please select the file that conforms to the type, reference type：',
    LicenseFilesNotUploaded: 'License related attachments not uploaded',
    companyProcessInAppToCreateProject: 'Company process is being approved, whether to create project based on the previous approved process?',
    patentCountryAppNoExist: 'Country:{0}, App No:{1} already exists in family members',
    confirmEmptyInfoAndOverwrittenFMListAfterSync: 'After synchronization, the patent information will be overwritten as empty, and the family member information will be overwritten,confirm continue?',
    confirmOnlyEmptyInfoAfterSync: 'The patent information will be overwritten as empty after synchronization,confirm continue?',
    confirmEmptyInfoAndUpdateFMListAfterSync: 'After synchronization, the patent information will be overwritten as empty, and the family member information will be updated,confirm continue?'
  }
}
